import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { BookingPassengerInfo, GroupTicketBaseData, GroupTicketProperties, GroupTicketSearchParameters, TicketResponseMessage, TicketSuppliersAccessCodeProperties } from '../Models/GroupTicketProperties';
import { BookingInfoProperties, PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { BookingListProperties } from '../Models/BookingListProperties';

@Injectable({
  providedIn: 'root'
})

export class GroupTicketService {
  baseUrl = environment.baseUrl;
  // backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) {

  }
  private handleError(errors: HttpErrorResponse):Observable<any> {
    let errorMessage:string = '';
    if (errors.status === 0) {
  
      //console.error('An error occurred:', errors.error);
      errorMessage = errors.error;
    } else {
     // console.error(`:${errors.status}`,errors.error );
      errorMessage =`${errors.status}` ;
    }
    errorMessage += '-Something Went Wrong! Please Try Again Later.'
    // Return an observable with a user-facing error message.
    return throwError(errorMessage);
  }
  GetTicketBaseData():Observable<GroupTicketBaseData> {
    return this.http.get<GroupTicketBaseData>(this.baseUrl + '/GroupTicket/GetTicketBaseData').pipe(map((data) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  GetTicketAccessCode(supplierId:string):Observable<TicketSuppliersAccessCodeProperties[]> {
    return this.http.get<TicketSuppliersAccessCodeProperties[]>(this.baseUrl + '/GroupTicket/GetTicketSupplierAccessCode?supplierId='+supplierId).pipe(map((data) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  SaveUpdateGroupTicket(groupTicket: GroupTicketProperties):Observable<TicketResponseMessage> {
    return this.http.post<TicketResponseMessage>(this.baseUrl + '/GroupTicket/SaveUpdateGroupTicket', groupTicket).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  GetAllGroupTicket(groupTicketSearch:GroupTicketSearchParameters):Observable<TicketResponseMessage> {
    return this.http.post<TicketResponseMessage>(this.baseUrl + '/GroupTicket/GetAllGroupTicket',groupTicketSearch).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  GetByIdGroupTicket(groupId:number):Observable<TicketResponseMessage> {
    return this.http.get<TicketResponseMessage>(this.baseUrl + '/GroupTicket/GetByIdGroupTicket?groupId='+groupId).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  DeleteGroupTicket(groupId:number):Observable<TicketResponseMessage> {
    return this.http.get<TicketResponseMessage>(this.baseUrl + '/GroupTicket/DeleteGroupTicket?groupId='+groupId).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  DeleteSegment(segmentId:number):Observable<TicketResponseMessage> {
    return this.http.get<TicketResponseMessage>(this.baseUrl + '/GroupTicket/DeleteSegment?segmentId='+segmentId).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  DeletePassenger(passengerId:number):Observable<TicketResponseMessage> {
    return this.http.get<TicketResponseMessage>(this.baseUrl + '/GroupTicket/DeletePassenger?passengerId='+passengerId).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  //UpdateIssueGroupTicketStatus(bookingId:number,groupId:number,groupTicketRequest:number):Observable<boolean> {
  //  return this.http.get<boolean>(this.baseUrl + '/GroupTicket/UpdateIssueGroupTicketStatus?bookingId='+bookingId+'&groupId='+groupId+'&groupTicketRequest='+groupTicketRequest).pipe(map((data:boolean) => {
  //    return data;
  //  }), catchError(this.handleError));
  //  //error => { return throwError(error)}
  //}

  UpdateIssueGroupTicketStatus(bookingId: number, groupId: number, groupTicketRequest: number, noOfTickets: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/GroupTicket/UpdateIssueGroupTicketStatus?bookingId=' + bookingId + '&groupId=' + groupId + '&groupTicketRequest=' + groupTicketRequest + '&noOfTickets=' + noOfTickets).pipe(map((data: boolean) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  IssueGroupTicket(bookingInfo:BookingInfoProperties):Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/GroupTicket/IssueGroupTicket',bookingInfo).pipe(map((data:PassengerCreationResponse) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  CancelGroupTicket(bookingInfo:BookingInfoProperties):Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/GroupTicket/CancelGroupTicket',bookingInfo).pipe(map((data:boolean) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  GetGroupTicketIssueRequestList():Observable<BookingListProperties[]> {
    return this.http.get<BookingListProperties[]>(this.baseUrl + '/GroupTicket/GroupTicketIssueRequestList').pipe(map((data:BookingListProperties[]) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
 
GetAllGroupTicketList(groupTicketSearch:GroupTicketSearchParameters):Observable<TicketResponseMessage> {
    return this.http.post<TicketResponseMessage>(this.baseUrl + '/GroupTicket/GetAllGroupTicketList',groupTicketSearch).pipe(map((data: TicketResponseMessage) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }


  GetGroupTicketPassengerDetails(groupTicketId: number): Observable<BookingPassengerInfo[]> {
    return this.http.get<BookingPassengerInfo[]>(this.baseUrl + '/GroupTicket/GroupTicketPassengerDetails/' + groupTicketId).pipe(map((data: BookingPassengerInfo[]) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }


}
